module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aM8oQ"))).then(() => parcelRequire('5erN3'));